import ConfigWidgetLabel from 'scoreboard/dashboards/widgets/config-widget-label'
import i18n from 'scoreboard/components/i18n'
import appDisplay from 'scoreboard/components/app-display'

/**
 * View for editing a chart accessory's label
 */
const ConfigChartAccessoryLabel = ConfigWidgetLabel.extend({

	_getModelLabel: function () {
		return this.model.properties.get('label')
	},

	_setModelLabel: function (label) {
		this.model.properties.set('label', label)
	},

	_getSuggestion: function () {
		return this.options.chartModel.get('label')
	}
})

function menu (configMenu, widgetModel, chartModel, labelCode) {
	const label = i18n.get(labelCode)
	return {
		type: 'dialog',
		label,
		target: function (e) {
			const Constructor = ConfigChartAccessoryLabel.extend({
				dialogTitle: labelCode
			})
			var configView = new Constructor({
				model: widgetModel,
				label,
				chartModel
			})

			appDisplay.dialog(configView)

			e.preventDefault()
			configMenu.trigger('done')
		}
	}
}

export default menu

menu.__filename__ = 'dashboards/widgets/chart/config/config-chart-accessory-label.js'
